export default state => ({
  ...state,
  isAuthenticated: false
});
